// Standard CRM page header. Mirrors the DashboardV2 PageShell header band
// (eyebrow dot + title + subtitle on the left, actions on the right) so every
// CRM tab reads like Projects/Team. The CRM tools that used to live in the
// top tab bar (company, project, palette) are pinned to the right of every
// header now that the tabs themselves live in the app sidebar.

import React from "react";
import ProjectSelector from "../molecules/ProjectSelector";
import CompanySwitcher from "../molecules/CompanySwitcher";
import { useCrmBreakpoint } from "../hooks/useCrmBreakpoint";

export default function PageHeader({ eyebrow = "CRM", title, subtitle, count, actions, topRight, tabs, tools = true }) {
  const { isMobile, pagePad } = useCrmBreakpoint();

  return (
    <div style={{ flexShrink: 0, padding: isMobile ? `14px ${pagePad}px 0` : "16px 24px 0" }}>
    <header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
        flexWrap: "wrap",
      }}
    >
      <div style={{ minWidth: 0 }}>
        {eyebrow && (
          <div style={{ display: "inline-flex", alignItems: "center", gap: 5, marginBottom: 2 }}>
            <span style={{ width: 5, height: 5, borderRadius: 99, background: "var(--crm-success)" }} />
            <span style={{ fontSize: 12, color: "var(--color-text-muted)" }}>{eyebrow}</span>
          </div>
        )}
        <h1 style={{ margin: 0, fontSize: 20, fontWeight: 500, lineHeight: "26px", letterSpacing: "-0.01em" }}>
          {title}
          {count != null && (
            <span style={{ marginLeft: 8, fontSize: 13, fontWeight: 400, color: "var(--color-text-secondary)", fontVariantNumeric: "tabular-nums" }}>
              {typeof count === "number" ? count.toLocaleString() : count}
            </span>
          )}
        </h1>
        {subtitle && (
          <p style={{ margin: "2px 0 0", fontSize: 12, lineHeight: "16px", color: "var(--color-text-secondary)" }}>{subtitle}</p>
        )}
      </div>

      <div className="tg-filterbar" style={{ flexWrap: "wrap" }}>
        {actions}
        {tools && (
          <>
            <CompanySwitcher />
            <ProjectSelector />
          </>
        )}
      </div>
    </header>

    {/* Second row: page tabs on the left, filters pushed right — the Projects
        and Team pages put every filter here rather than beside the buttons. */}
    {(topRight || tabs) && (
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        gap: 16, marginTop: 12, minHeight: 34,
        borderBottom: tabs ? "1px solid var(--color-border-subtle)" : "none",
      }}>
        {/* dashv2-tabbar keeps the row scrollable on narrow screens without the
            scrollbar gutter, which otherwise draws a stray line after the tabs. */}
        {/* overflowY hidden: overflowX:auto alone also makes the row scroll vertically, and
            tab underlines that poke 1px past the row produced a 1px vertical scrollbar. */}
        <div className="dashv2-tabbar" style={{ display: "flex", alignItems: "center", gap: 2, minWidth: 0, overflowX: "auto", overflowY: "hidden", alignSelf: "stretch" }}>{tabs}</div>
        {topRight && (
          <div className="tg-filterbar" style={{ flexShrink: 0, flexWrap: "wrap", justifyContent: "flex-end" }}>{topRight}</div>
        )}
      </div>
    )}
    </div>
  );
}
